export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.d06df622.woff";